import instance from '../../data/api/api.api';
import {
	ISurveysConsultRequest,
	ISurveysConsultResponse,
} from '../models/survey-consult.model';
import {
	ISurveysReceiveRequest,
	ISurveysReceiveResponse,
} from '../models/survey-receive.model';

export const surveysConsultUseCase = async (
	body: ISurveysConsultRequest
): Promise<ISurveysConsultResponse> => {
	const { data } = await instance.post<ISurveysConsultResponse>(
		`${process.env.REACT_APP_API_URL}/surveys/consult`,
		body
	);
	return data;
};

export const surveysReceiveUseCase = async (
	body: ISurveysReceiveRequest
): Promise<ISurveysReceiveResponse> => {
	const { data } = await instance.post<ISurveysReceiveResponse>(
		`${process.env.REACT_APP_API_URL}/surveys/receive`,
		body
	);
	return data;
};
